import React from 'react';
import { connect } from 'react-redux';
import drawingUtils from '../utils/DrawingUtils';
import createShapes from '../utils/CreateShapes';
import Draggable from 'react-draggable';
import modeType from '../../constants/ModeConstants';
import storeManager from '../../store/StoreManager';
import appParameters from '../utils/AppParameters';
import mouseUtils from '../../components/utils/MouseUtils';
import configuration from '../../constants/Configuration';
import textSizeUtils from '../utils/TextSizeUtils';
import platformDetection from "../utils/PlatformDetection";

const DrawAreaContent = React.createClass({
    getInitialState () {
        return {
            path: '',
            points: [],
            draw: false
        };
    },
    componentDidMount() {
        document.addEventListener('touchend', this.onStop);
        document.addEventListener('mouseup', this.onStop);
    },
    componentWillUnmount() {
        document.removeEventListener('touchend', this.onStop);
        document.removeEventListener('mouseup', this.onStop);
    },
    onStart (e) {
        e.preventDefault();

        if (this.props.drawState == 'none')
            return;

        this.setState({
            path: '',
            points: [],
            draw: true
        });
    },
    onMove (e) {
        e.preventDefault();

        if (this.state.draw == false)
            return;

        let newPath = '';
        let point = this.convertPoint(drawingUtils.getTouchPosition(e));
        let type = this.props.drawState;
        let pathPoints = this.state.points;

        if (type == modeType.LINE_CONTEXT) {
            if (this.state.path.length < 1) {
                newPath = `M${point.x},${point.y}`;
            }  else {
                newPath = `M${pathPoints[0].x},${pathPoints[0].y}L${point.x},${point.y}`;
            }
        } else if (type == modeType.FREEHAND_CONTEXT) {
            if (this.state.path.length < 1)
                newPath = `M${point.x},${point.y}`;
            else
                newPath = this.state.path + ',L' + point.x + ',' + point.y;
        }

        pathPoints.push(point);

        this.setState({
            path: newPath,
            points: pathPoints
        });

        this.drawObject(type);
    },
    convertPoint(point) {
        const topX = this.props.scaleProperties.topX;
        const topY = this.props.scaleProperties.topY;
        const scale = this.props.scaleProperties.scale;

        var xValue = (point.x - topX) / scale;
        var yValue = (point.y - topY) / scale;

        return {x: xValue.toFixed(2) , y: yValue.toFixed(2)};
    },
    drawObject (type) {
        const points = this.state.points;

        if (points.length < 2)
            return;

        var drawingProperties = drawingUtils.getDrawingProperties();
        var c = document.getElementById('drawCanvas');
        var ctx = c.getContext('2d');
        var i;
        var point = points[0];

        this.clearCanvas();

        ctx.beginPath();
        ctx.lineWidth= drawingProperties.strokeWidth;
        ctx.strokeStyle = drawingProperties.strokeColor;
        ctx.moveTo(point.x, point.y);

        if (type == modeType.LINE_CONTEXT) {
            point = points[points.length - 1];
            ctx.lineTo(point.x, point.y);
        } else {
            for (i=1; i<points.length; i++) {
                point = points[i];
                ctx.lineTo(point.x, point.y);
            }
        }

        ctx.stroke();
    },
    clearCanvas () {
        var c = document.getElementById('drawCanvas');

        if (c == undefined)
            return;

        var ctx = c.getContext('2d');
        ctx.clearRect(0, 0, c.width, c.height);
    },
    onStop (e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.state.draw == true) {
            if (!platformDetection.isIOS())
                e.preventDefault();

            const {dispatch} = this.props;

            let type = this.props.drawState;

            if (type == modeType.LINE_CONTEXT) {
                createShapes.createLine(dispatch, this.state.path, drawingUtils.getDrawingProperties());
            } else if (type == modeType.FREEHAND_CONTEXT) {
                createShapes.createFreehand(dispatch, this.state.path, drawingUtils.getDrawingProperties());
            }

            this.clearCanvas();

            this.setState({
                path: '',
                points: [],
                draw: false
            });
        }
    },
    render() {
        if (appParameters.getMode() == modeType.PLAYER || this.props.mode == modeType.PREVIEW) {
            const drawAreaPreviewStyle = {
                position: 'absolute',
                width: configuration.CANVAS_WIDTH,
                height: configuration.CANVAS_HEIGHT,
                top: 0,
                left: 0,
                display: 'block'
            };

            return (<div style={drawAreaPreviewStyle}/>);
        }

        var displayState;

        if (this.props.drawState == undefined || this.props.drawState == 'none') {
            displayState = 'none';
            return (<div/>);
        } else
            displayState = 'block';

        const drawAreaStyle = {
            position: 'absolute',
            width: configuration.CANVAS_WIDTH,
            height: configuration.CANVAS_HEIGHT,
            top: 0,
            left: 0,
            display: displayState,
            cursor: 'crosshair'
        };

        const backgroundAreaStyle = {
            position: 'absolute',
            width: configuration.CANVAS_WIDTH,
            height: configuration.CANVAS_HEIGHT,
            top: 0,
            left: 0,
            background: 'white',
            opacity: 0.1
        };

        const canvasStyle = {
            position: 'absolute',
            top: 0,
            left: 0
        };

        return (
            <div style={drawAreaStyle}>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onStart} onDrag={this.onMove}>
                    <div ref="drawingArea">
                        <canvas id="drawCanvas" width={configuration.CANVAS_WIDTH} height={configuration.CANVAS_HEIGHT} style={canvasStyle}/>
                    </div>
                </Draggable>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const drawState = state.accordion.drawState;

    return {
        drawState
    };
}

export const DrawArea = connect(mapStateToProps)(DrawAreaContent);



/** WEBPACK FOOTER **
 ** ./src/components/slide/DrawArea.js
 **/